import {ChangeDateFormat} from "../../../Common/Helpers/ChangeDateFormat";

class ResponseQueuedPaymentsModel{
    constructor({
                    date = ChangeDateFormat('date', new Date()),
                    value = 0,
                    done = null,
                    status = '',
                    payoutVisualId = '', 
                    payoutDate = ChangeDateFormat('date', new Date()),
                    net = 0,
                } = {}) {
        this.date = date ? ChangeDateFormat('date', date) : '' ;
        this.value = value;
        this.done = done;
        this.status = status;
        this.payoutVisualId = payoutVisualId;
        this.payoutDate = payoutDate ? ChangeDateFormat('dateTime', payoutDate) : '' ;
        this.net = net;
    }

    static getAttributes(filter = null, validationSchema = null) {
        const attributes = {
            date :{
                'sortable': true,
                'sortField': 'date',
                'value': (item) => item.date ? ChangeDateFormat('dateTime', item.date) : 'not set'|| "not set",
            },
            value :{
                'sortable': true,
                'sortField': 'value',
                'value': (item) => item.value || "",
            },
            done :{
                'sortable': true,
                'sortField': 'done',
                'value': (item) => item.done || "",
            },
            net :{
                'sortable': true,
                'sortField': 'net',
                'value': (item) => item.net || "",
            },
        }

        return attributes;
    }
}
export default ResponseQueuedPaymentsModel;